export const ETH_TOKEN_ADDRESS = '0x0000000000000000000000000000000000000000';
export const ETH_AVERAGE_BLOCK_TIME = 12 * 1000;
export const ETH_ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';
export const BASE_AVERAGE_BLOCK_TIME = 3 * 1000;
